import React from "react";
import { AccountTile } from "./AccountTile";
import { PasswordTile } from "./PasswordTile";
export var AccountTabTiles = function AccountTabTiles() {
  return React.createElement("div", null, React.createElement(AccountTile, null), React.createElement(PasswordTile, null));
};